import React from "react";

import type { TableHeadersType } from "@/constant/tableHeadersConstants/tableHeadersType";

interface Props {
  tableHeader: TableHeadersType[];
  extraHeader?: boolean;
  textCenter?: boolean;
  multiCheckBox?: boolean;
  onCheckboxChange?: (checked: boolean) => void;
  isChecked?: boolean;
  showCheckBox?: boolean;
}

const Tableheader = ({
  tableHeader = [],
  extraHeader,
  textCenter,
  multiCheckBox,
  onCheckboxChange,
  isChecked,
  showCheckBox,
}: Props) => {
  const handleCheckboxClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onCheckboxChange) {
      onCheckboxChange(e.target.checked);
    }
  };

  return (
    <tr>
      {multiCheckBox && (
        <th style={{ width: "20px" }}>
          {showCheckBox && (
            <input
              type="checkbox"
              name="fordCheckBox"
              checked={isChecked}
              style={{
                width: "19px",
                height: "19px",
                backgroundColor: "red",
              }}
              className="checkbox"
              onChange={handleCheckboxClick}
              disabled
            />
          )}
        </th>
      )}
      {tableHeader.map((item, index) => {
        if (item) {
          return (
            <th
              className={`${textCenter ? "text-center" : ""}`}
              key={item?.value}
              style={{
                width: item?.width ? item?.width : "120px",
                paddingLeft: item?.padding ? item?.padding : "20px",
              }}
            >
              {item?.label}
            </th>
          );
        } else {
          return null;
        }
      })}
      {extraHeader && <th></th>}
    </tr>
  );
};

export default Tableheader;
